import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import authIcon from "../../assets/images/mfa/authios.jpg";
import { SubTitle, Title, ModalContainer, Label, SubLabel } from "./styles";
import "./styles.css";
import { ButtonPrimary } from "../../ui/buttons";

function AppsModal({ toggle, isOpen, handleNextModal }) {
  const handleContinuar = () => {
    handleNextModal();
    // toggle();
  };
  return (
    <ModalContainer>
      <Modal isOpen={isOpen} toggle={toggle} centered contentClassName="custom-modal">
        <ModalHeader className="border-0 p-1" toggle={toggle} />
        <ModalBody className="pt-0 p-0">
          <>
            <Title>Habilitar autenticación de dos factores</Title>
            <SubTitle>Mejora la seguridad de tu cuenta en tres simples pasos.</SubTitle>
            <div className="p-4 w-100 d-flex flex-column justify-content-center align-items-center">
              <Label>DESCARGA MICROSOFT AUTHENTICATOR</Label>
              <SubTitle>Descargue e instale la aplicación en su dispositivo móvil</SubTitle>
              <SubLabel>
                {"Android: "}
                <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" style={{ color: "#4B47FF" }}>
                  <img className="lazyloaded" src={authIcon} alt="icono authenticator" style={{ width: "15px", marginRight: "5px" }} />
                  Microsoft Authenticator
                </a>
              </SubLabel>
              <SubLabel>
                {"IOS: "}
                <a href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458" style={{ color: "#4B47FF" }}>
                  <img className="lazyloaded" src={authIcon} alt="icono authenticator" style={{ width: "15px", margin: "0 5px" }} />
                  Microsoft Authenticator
                </a>
              </SubLabel>
            </div>
          </>
        </ModalBody>
        <ModalFooter className="border-0 pt-0">
          <Button color="btn-secondary mr-2" style={{ height: "40px" }} onClick={toggle}>
            Cancelar
          </Button>
          <ButtonPrimary onClick={handleContinuar}>Continuar</ButtonPrimary>
        </ModalFooter>
      </Modal>
    </ModalContainer>
  );
}

export default AppsModal;
